export default __webpack_public_path__ + "components/weather-icon/static/nightmodsnow@2-a6f6cfa3fe9f3e3c923d3ddefd783e5a.png";